<template>
  <div class="layout" id="app">

    <template v-if="$route.path=='/login' || $route.path=='/'">
      <router-view></router-view>
    </template>
    <template v-else>
      <Layout :style="{minHeight: '100vh'}">

        <Layout>
          <Sider breakpoint="md" :collapsed-width="78" :width="210" collapsible v-model="isCollapsed">
            <Menu :class="menuitemClasses" active-name="$route.name" style="background: #fff; box-shadow: 0px 4px 12px 1px rgba(0, 0, 0, 0.13);" theme="dark" width="auto" :open-names="[]">
              <MenuItem style="width: 100%;" name="logo">
                <ul style="display: flex; list-style: none;">
                  <li>
                    <div style="width: 25px; height: 25px;">
                      <img src="../src/assets/logo.png" style="width: 100%; z-index: 1000; color: black;" alt="logo">
                    </div>
                  </li>
                  <li style="margin-left: 10px; ">
                    <span><img src="../src/assets/text.png" alt=""></span>
                  </li>
                </ul>
              </MenuItem>
              <Divider style="margin: unset"></Divider>

           <template v-for="menu in menuArr">
           <MenuItem v-if="menu.title && menu.subMenu.length === 1" :name="menu.subMenu[0].title" :to="menu.subMenu[0].url"
                     :style="menu.subMenu[0].title=='Settings'?'position: absolute; bottom: 100px; width: 100%;':''">
              <ul style="display: flex; list-style: none; ">
                <li style="margin: 0 5px 0 -4px">
                  <div style="width: 25px; height: 25px">
                  <i :class="menu.subMenu[0].icon_class" :title="menu.subMenu[0].title"></i>
                  </div>
                </li>
                <li style="">
                  <span>{{menu.title}}</span>
                </li>
              </ul>
            </MenuItem>
            <Submenu :name="menu.title" v-else-if="menu.title && menu.subMenu.length > 1">
              <div slot="title" style="color: black">
                <i :class="menu.menuIcon" style="margin-left: -5px"></i>
                <span :style="isCollapsed?'':'padding: 0 0 0 17px;'">{{menu.title}}</span>
              </div>
                <MenuItem v-for="(submenu, index) in menu.subMenu" :name="submenu.title" :to="submenu.url" :key="index">
                  <ul style="display: flex; list-style: none; ">
                  <li>
                    <div style="width: 25px; height: 25px">
                      <i :class="submenu.icon_class"></i>
                    </div>
                  </li>
                  <li style="margin-left: 10px;">
                    <span>{{submenu.title}}</span>
                  </li>
                </ul>
                </MenuItem>
             </Submenu>
            </template>

              <MenuItem style="position: absolute; bottom: 50px; width: 100%;" name="Logout">
                <ul style="display: flex; list-style: none;"  @click="logout">
                  <li style="margin: 0 5px 0 -4px">
                    <div style="width: 25px; height: 25px">
                      <i class="fas fa-power-off"></i>
                    </div>
                  </li>
                  <li style="">
                    <span>Logout</span>
                  </li>
                </ul>
              </MenuItem>



          </Menu>
          </Sider>
          <Content :class="isCollapsed?'content-collapsed':'content-tag'">
            <div class="container-padding" style="background-color: #f2f7fa; color:black;letter-spacing: 0.14px; font-family: Helvetica;">
              <div style=" border-bottom: 1px solid #e8e8e8; padding: 15px">
                <h3>
                  <template v-if="$route.params.id">
                    <i class="fas fa-arrow-left left-arrow" @click="goBack()"></i>
                  </template>
                  {{$route.name}}
                <template v-if="count_routes.includes($route.path)">({{count}})</template>
                </h3>

<!--                  <div v-if="totalWeight_routes.includes($route.path)" :class="$route.path.substr(1)">-->
<!--                      Total Wt.: {{totalWeight}} kg-->
<!--                  </div>-->
                  <template v-if="globalSearch_routes.includes($route.path)">
                    <Input @on-keydown="debounceInput" id="search-field" :placeholder="getPlaceholder()" style="width: 300px; float: right; margin: -30px 0 0 0"/>
                  </template>
              </div>
              <Card>
                <div style="height: 100%;">
                  <router-view :globalSearch="globalSearch" @totalWeightOfSelectedOrders="totalWeight=$event"
                                @onCount="count=$event"></router-view>
                </div>
              </Card>
            </div>

          </Content>
        </Layout>
      </Layout>
    </template>

  </div>
</template>
<script>

  import THeader from './components/Common/THeader'
  import _ from 'lodash'
  import {GET_MAPPED_AREAS} from "./graphql/queries/area";
  import {GET_MAPPED_USERS} from "./graphql/queries/users";
  import {convertArrToJSON} from "./util/helpers";
  export default {
    name: 'app',
    components: { THeader },
    apollo: {
      area: {
        query: GET_MAPPED_AREAS,
        result ({ data }) {
          let mappedAreas = {}
          data.area.forEach(a => mappedAreas[a.area.toLowerCase()] = a.areaGroup.name)
          this.$store.commit('setMappedAreas', mappedAreas)
        },
      },
      users: {
        query: GET_MAPPED_USERS,
        result ({ data }) {
          let mappedUsers = convertArrToJSON(data.users, 'id')
          this.$store.commit('setMappedUsers', mappedUsers)
        },
      },
    },
    data () {
      return {
        isCollapsed: false,
        userObj: '',
        orders_submenuArr: [
            {title:'Open Orders', url:'/orders', icon_class:'fas fa-shopping-cart'},
            // {title:'Completed Orders', url:'/completed-orders', icon_class:'fas fa-cart-arrow-down'},
            {title:'Cancel Orders', url:'/cancel-orders', icon_class:'fas fa-cart-plus'},
            {title:'Rejected Orders', url:'/rejected-orders', icon_class:'fas fa-luggage-cart'}
            ],
          count_routes: ['/excel-clients','/excel-transporters','/excel-contractors'],
          totalWeight_routes: ['/orders', '/excel-formatted-orders'],
          globalSearch_routes:['/orders', '/completed-orders', '/cancel-orders', '/rejected-orders', '/excel-formatted-orders',
                               '/excel-clients', '/excel-transporters', '/excel-contractors', '/lr',
                               '/create-client-invoices', '/authorize-client-invoices', '/client-invoices', '/canceled-client-invoices'],
          count: '',
          totalWeight: 0,
          globalSearch: ''
      }
    },
    computed: {
      menuitemClasses: function () {
        return [
          'menu-item main-menu',
          this.isCollapsed ? 'collapsed-menu' : ''
        ]
      },
      menuArr: function(){
          return this.$store.state.userObj?this.$store.state.userObj.menu : []
      },
      userName: function(){
        return this.$store.state.userObj?this.$store.state.userObj.user.name : ''
      }
    },
    methods: {
      getPlaceholder(){
          let placeholder = 'Search by party, order no, LR etc'
          if(['/excel-clients','/excel-transporters','/excel-contractors'].includes(this.$route.path)){
              placeholder = 'Search by name, mobile, gstin etc'
          }else if(this.$route.path === '/lr'){
            placeholder = 'Search by consignor, consignee, LR etc'
          }else if(this.$route.path === '/client-invoices'){
            placeholder = 'Search by invoice no., client name etc'
          }
          return placeholder
      },
      debounceInput: _.debounce(function (e) {
          this.globalSearch = e.target.value
      }, 500),
      logout () {
        this.$Modal.confirm({
          title: 'Logout',
          content: '<p>Are you Sure, you want to Logout?</p>',
          onOk: () => {
            localStorage.clear()
            this.$Message.warning('Successfully Logout')
            this.$router.go()
          },
          onCancel: () => {
            this.$Message.info('Logout Cancelled.')
          }
        })
      },
      goBack(){
          this.$router.go(-1)
      }

    },
    beforeMount () {

    },
  }
</script>
<style scoped>
 /deep/ .layout-con {
    height: 100%;
    width: 100%;
  }

  .menu-item span {
    display: inline-block;
    overflow: hidden;
    width: 130px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width .2s ease .2s;
    color: #5b5777;
    font-size: 15px;
  }

  .menu-item i {
    transform: translateX(0px);
    transition: font-size .2s ease, transform .2s ease;
    vertical-align: middle;
    font-size: 15px;
    color: #5b5777;
  }

  .collapsed-menu span {
    width: 0px;
    transition: width .2s ease;
  }

  .collapsed-menu i {
    transform: translateX(5px);
    transition: font-size .2s ease .2s, transform .2s ease .2s;
    vertical-align: middle;
    /*font-size: 22px;*/
  }
  /*/deep/ .ivu-layout-sider-children{*/
  /*  position: fixed;*/
  /*}*/
 /deep/ .main-menu{
    min-height: 100%;
    padding: 0 0 200px 0;
  }
  /deep/ .ivu-card{
    background: #f2f7fa!important;
  }
  /deep/ .ivu-layout-sider{
    z-index: 1000;
    background:none !important;
    position: fixed;
    overflow-y: scroll;
    height: 100vh;
    overflow-x: hidden;
  }
 .content-collapsed{
   margin-left: 70px;
   transition: margin-left ease 200ms;
 }
 .content-tag{
   margin-left: 200px;
   transition: margin-left ease 200ms;
 }
  /deep/ .ivu-card:hover{
    box-shadow: none !important;
  }
  /deep/ .ivu-card-bordered{
    border: none !important;
  }
 /deep/ .ivu-layout-sider-trigger{
   background: #f2f7fa;
   color: black;
 }
  /deep/.ivu-menu-vertical .ivu-menu-submenu-title-icon{
    right: 6px;
    color: black;
  }
    /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened{
        background-color: #fff;
    }
    /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active,
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active,
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active,
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:hover,
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:hover,
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover{
        background: #fff !important;
    }
   /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover{
     background: none !important;
   }
    /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover i{
      color: #e74824 !important;
    }
    /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover span{
      color: #e74824 !important;
    }

    /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover{
      background: none !important;
    }
   /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover .fas{
     color: #e74824 !important;
   }
   /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover .far{
     color: #e74824 !important;
   }
   /deep/ .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover span{
     color: #e74824 !important;
   }
    /deep/ .ivu-menu-item-selected .fas{
      color: #e74824 !important;
    }
    /deep/ .ivu-menu-item-selected .far{
      color: #e74824 !important;
    }
  /deep/ .ivu-menu-item-selected span{
      color: #e74824 !important;
    }
 /deep/.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
     background: #fff;
 }
  /deep/.handsontable > .ht_master > .wtHolder{
    max-height: 65vh !important;
    overflow: auto ;
  }
</style>
<style>
    .orders{
        margin: -24px 100px 0
      }
    .excel-formatted-orders{
        margin: -24px 280px 0
      }
    .cell-readonly{
      color: #777777;
    }
  .left-arrow{
    font-size: 15px;
    margin-right: 12px;
    cursor: pointer;
  }
    .ivu-layout-sider::-webkit-scrollbar {
      width: 5px !important;
      height: 5px !important;
      display: block !important;
    }
    .ivu-layout-sider::-webkit-scrollbar-thumb {
      background: #e4eaf5 !important;
      border-radius: 5px !important;
    }
  .fs-16{
    font-size: 16px;
  }
</style>
